<template>
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <span class="cursor-pointer flex items-center i18n-locale">
      <i class="mr-2 flag-icon h-4 w-5" :class="getCurrentLocaleData.icon"/>
      <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.text }}</span>
    </span>

    <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
      <vs-dropdown-item v-for="(lang) in getLanguageOptions" @click="updateLocale(lang.value)" :key="lang.value">
        <i class="mr-2 flag-icon" :class="lang.icon"/>
        {{ lang.text }}
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import {getLanguageChoices} from '@/helpers/lists';

export default {
  name: 'i18n',
  computed: {
    getCurrentLocaleData () {
      const locale = this.$i18n.locale;
      let lang = {};
      getLanguageChoices().forEach((l) => {
        if (locale === l.value) {
          lang = l;
        }
      });
      return lang;
    },
    getLanguageOptions() {
      return getLanguageChoices();
    }
  },
  methods: {
    updateLocale (locale) {
      this.$store.dispatch('Lang/SwitchLanguage', { lang: locale, i18n: this.$i18n });
    }
  }
}
</script>
